<!--
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-06-01 08:57:21
 * @LastEditors: WangYuan
 * @LastEditTime: 2021-09-26 15:18:52
-->
<template>
  <config-item v-show="isSupport" :label='mValue.showType=="text"?label:""'>
    <div>
      <!--      curWidget:{{control.curWidget.component}}-->
      <div v-if="mValue.showType=='text'||!mValue.showType">

        <el-select style="width: 100%" v-model="mValue.decoratorId" size="small" @change="switchPageStyle">
          <el-option v-for="item in tagList" :label="item.name" :key="item.decoratorId" :value="item.decoratorId" />
        </el-select>
      </div>

      <div v-else-if="mValue.showType=='image'">


        <div v-if="mValue.showTitle==true||mValue.showSubtitle==true"
             style="display: flex;justify-content: space-between;align-items: center;padding-bottom:20px;font-size:14px;">
          <div v-if="mValue.showTitle==true" style="color:#969799;">{{mValue.title}}</div>
          <div v-if="mValue.showSubtitle==true" style="color:#155bd4;">{{mValue.subTitle}}</div>
        </div>

        <div>
          <div v-for="(item,index) in tagList" :key="index" class="div">
            <el-image :src="project.filePath+item.image"
                      @click="switchPageStyle(item.decoratorId)"
                      :class="item.decoratorId==mValue.decoratorId?'cur':'normal'">
            </el-image>

            <span class="iconfont icon-xuanzhong" v-if="item.decoratorId==mValue.decoratorId" ></span>
          </div>
        </div>

        <!--是否为默认装饰器-->
        <div class="setDefaultDec" v-if="mValue.showRoleList==true&&decoratorList[mValue.decoratorId]&&decoratorList[mValue.decoratorId].roleList">
          <div style="color:#969799;font-size:14px;flex:1">是否为默认装饰器</div>

          <el-image src="https://cdn.zhaosheng.daheyun1314.com/training/d50eb4ed0eeb40adbbeb47c50ca84b92.png"
                    v-if="mValue.defaultDecoratorId!=mValue.decoratorId"
          @click="changeDefault" style="width:45px;height:23px;cursor:pointer"
          ></el-image>

          <el-image src="https://cdn.zhaosheng.daheyun1314.com/training/60024111a086472f8e0d15c14d865019.png"
                    style="width:45px;height:23px;"
                    @click="changeDefault1"
                    v-else></el-image>

        </div>

        <!--是否为默认装饰器-->

        <div class="userRole" v-if="mValue.showRoleList==true&&decoratorList&&decoratorList[mValue.decoratorId]&&decoratorList[mValue.decoratorId].roleList">

          <div style="color:#969799;font-size:14px;flex:1">应用角色</div>

          <div>
            <el-select size="small"  multiple placeholder="请选择" v-model="decoratorList[mValue.decoratorId].roleList"
                       @change="getRoleList"
            >
              <el-option
                  v-for="item in project.roleList"
                  :key="item.sign"
                  :disabled="getIsCheck(item.sign)"
                  :label="item.name"
                  :value="item.sign">
              </el-option>
            </el-select>
          </div>

        </div>

      </div>

    </div>



  </config-item>
</template>

<script>
import schemaMixin from "@/mixin/schemaMixin";
import { getDecoratorListByRuleIds } from "../../../api/easyApp";

import { deepClone } from "@/js/utils";
import { mapGetters } from "vuex";

export default {
  name: "SchemaDecSource",
  mixins: [schemaMixin],
  props: {
    labelSwitch: {
      default: true,
    },
    isShow: {
      default: true,
    },
    tags: {
      type: String,
      default: "",
    },
    value: {
      default: () => ({}),
    },

  },

  inject: ['mode', "control"],

  computed: {
    ...mapGetters(["project", "curPage"])
  },
  data() {
    return {
      tagList: [],
      valueNew: '',
      show: false,
      defaultOptions: {
        max: 100,
      },
      pageStyle: [],
      isSupport: true,
      roleList:[],
      newList:[],
      decoratorList:[]
    };
  },

  /*  watch: {
      valueNew: {
        immediate: true,
        deep:true,
        handler(newVal,oldVal) {
          //this.value = this.valueNew;
        },
      },
    },*/

  async created() {


    this.roleList=this.project['roleList'];
    // 已启用「列表布局选择」时不展示本面板（分类列表卡片由小程序匹配）
    if (
      this.control &&
      this.control.curWidget &&
      this.control.curWidget.attrs &&
      this.control.curWidget.attrs.layoutSource
    ) {
      this.isSupport = false;
      return;
    }
    //根据当前组件判断下是否支持装饰器
    let info = this.project.appComList.find((page) => page.componentSign == this.control.curWidget.component);
    if (info && info.supportDecorator == 1) {
      let data = {
        ruleIds: this.tags
      }
      let res = await getDecoratorListByRuleIds(data);
      this.tagList = res.data;


      if(this.mValue.showRoleList==true&&!this.mValue.decoratorList[this.tagList[0].decoratorId]){
        this.mValue.decoratorList= {};

        let list=deepClone(res.data);
        for(const i in list){

          let obj={
            ...list[i],
            roleList:[],
            pageStyle:[]
          }
          this.mValue.decoratorList[list[i].decoratorId]=obj;

        }

        console.log("this.mValue.decoratorList:",this.mValue.decoratorList);

        if(this.mValue.decoratorList){


          if(!this.mValue.decoratorId){
            this.mValue.decoratorId=this.tagList[0].decoratorId;
            this.switchPageStyle(this.mValue.decoratorId);
          }

          this.decoratorList=deepClone(this.mValue.decoratorList);



        }







      }
      else if(this.mValue.showRoleList==true&&this.mValue.decoratorList[this.tagList[0].decoratorId]){
        this.decoratorList=deepClone(this.mValue.decoratorList);
      }


      if(!this.mValue.decoratorId){
        this.switchPageStyle(this.tagList[0].decoratorId)
      }




    }
    else {
      this.isSupport = false;
    }



  },
  methods: {
    getRoleList(e){

      if(this.mValue.decoratorId){
        this.mValue.decoratorList[this.mValue.decoratorId].roleList=deepClone(this.decoratorList[this.mValue.decoratorId].roleList);

        console.log("this.mValue.decoratorList[this.mValue.decoratorId].roleList:",this.mValue.decoratorList[this.mValue.decoratorId].roleList);



      }

    },
    getIsCheck(sign){
      //console.log("sign:",sign);
      let num=0;
      for(const i in this.decoratorList){


        //console.log("this.decoratorList:",this.decoratorList[i].roleList);
        if(this.decoratorList[i].roleList.length>0){

          let index = this.decoratorList[i].roleList.findIndex((item) => item == sign);

          if(index!=-1){
            num++;
          }
        }

      /*  let i = this.decoratorList[i].roleList.findIndex((item) => item.sign == sign);
        if(i!=-1){
          num++;
        }*/

      }

      //console.log("num:",num);

      if(num==0){
        return false
      }
      else{
        return true;
      }


    },
    btnSure() {
      this.mValue.pageStyle = deepClone(this.pageStyle)
      this.show = false;
    },
    btnClose() {
      this.show = false;
    },
    changeDefault(){

      if(this.mValue.decoratorId){
        this.mValue.defaultDecoratorId=this.mValue.decoratorId;
        this.mValue.defaultPageStyle=deepClone(this.mValue.pageStyle);
      }

    },
    changeDefault1(){
      let list=[];
      this.mValue.defaultDecoratorId='';
      this.mValue.defaultPageStyle=deepClone(list);
    },
    switchPageStyle(e) {
      //console.log("eeeeexxxxxx:",e);
      //console.log("this.mValue.decoratorList[e]:",this.mValue.decoratorList[e]);

      this.mValue.decoratorId=e;

      let index = this.tagList.findIndex(
          (item) => item.decoratorId == e
      );

      if(index!=-1){
        this.mValue.decoratorName=this.tagList[index].name;
      }

      if(this.mValue.showRoleList==true){

        if(this.mValue.decoratorList[e].pageStyle.length==0){
          let res=this.getRealPageStyle(index);
          this.mValue.pageStyle=res;
          this.mValue.decoratorList[e].pageStyle=res;
        }
        else{
          this.mValue.pageStyle=this.mValue.decoratorList[e].pageStyle;
        }

      }
      else{
        let res=this.getRealPageStyle(index);
        this.mValue.pageStyle=res;
      }

    },
    getRealPageStyle(index){
      let mvalue = JSON.parse(this.tagList[index].config);
      for (var i in mvalue) {
        let row = mvalue[i];

        for (var j in row) {
          let cols = row[j];
          if (j === "__rowSpan" || !Array.isArray(cols)) {
            continue;
          }

          for (var h in cols) {
            if (!cols[h] || typeof cols[h] !== "object") {
              continue;
            }

            if (cols[h]['type'] && cols[h]['type'] == 'divider') {

              cols[h]['style'] = {
                "width":'100%',
                "height": 1,
                "margin-top": 0,
                "margin-bottom": 15,
                'background': '#f5f5f5',
              }

            }
            else if (cols[h]['type'] && cols[h]['type'] == 'image') {
              cols[h]['style'] = {
                "width": 20,
                "height": 20,
                "borderRadius": 10,
                "margin-top": 0,
                "margin-left": 0,
                "margin-right": 0,
                "margin-bottom": 0
              }


            } else if (cols[h]['type'] && cols[h]['type'] == 'icon') {
              cols[h]['style'] = {
                'font-size': '20px',
                'color': '#409fee',
                "margin-top": 0,
                "margin-left": 0,
                "margin-right": 0,
                "margin-bottom": 0
              }
            } else if (cols[h]['type'] &&
                (cols[h]['type'] == 'text'
                    ||cols[h]['type'] == 'timeYearMonthDay'
                    ||cols[h]['type'] == 'timeYearMonth'
                    ||cols[h]['type'] == 'timeMonthDay'
                    ||cols[h]['type'] == 'timeSecond'
                    ||cols[h]['type'] == 'textS'
                    ||cols[h]['type'] == 'address-province'
                    ||cols[h]['type'] == 'address-city'
                    ||cols[h]['type'] == 'address-province-city'
                    ||cols[h]['type'] == 'address-city-district'
                    ||cols[h]['type'] == 'address-province-city-district'
                    ||cols[h]['type'] == 'address-district'
                    ||cols[h]['type'] == 'add-minus'
                )) {
              cols[h]['style'] = {
                'font-size': '14px',
                'font-weight': 'normal',
                'color': '#333',
                "margin-top": 0,
                "margin-left": 0,
                "margin-right": 0,
                "margin-bottom": 0
              }
            }
            else if (cols[h]['type'] &&
                (cols[h]['type'] == 'textArray'
                )) {
              cols[h]['style'] = {
                'font-size': '14px',
                'font-weight': 'normal',
                'color': '#999',
                'background': '#f5f5f5',
                'tagMrginLeft': 3,
                "margin-top": 0,
                "margin-left": 0,
                "margin-right": 0,
                "margin-bottom": 0
              }
            }

            else if (cols[h]['type'] && ( cols[h]['type'] == 'priceF' || cols[h]['type'] == 'priceY')) {
              cols[h]['style'] = {
                'font-size': '14px',
                'font-weight': 'normal',
                //'color': '#333',
                'freeColor':'#333',
                'noFreeColor':'#333',
                "margin-top": 0,
                "margin-left": 0,
                "margin-right": 0,
                "margin-bottom": 0
              }
            }
            else{
              cols[h]['style'] = {
                'font-size': '14px',
                'font-weight': 'normal',
                'color': '#333',
                "margin-top": 0,
                "margin-left": 0,
                "margin-right": 0,
                "margin-bottom": 0
              }
            }
          }

        }

      }
      return mvalue;
    },
    //弹出分组框
    btnShowGroup() {
      this.pageStyle = deepClone(this.mValue.pageStyle)
      this.show = true;
    },
  }


};
</script>

<style lang="scss" scoped>
@import "../iconfont-designer.css";

.icon-xuanzhong{
  color:#155bd4;
  position: absolute;
  right:0px;
  bottom:12px;
  font-size:20px;
}

.div{
  width:calc(33.33% - 10px);
  margin-right:10px;
  display: inline-block;
  float: left;
  position: relative;
}

.normal{
  width:100%;
  height:80px;
  padding:20px 0px;
  border:1px solid #ededed;
  cursor: pointer;
  border-radius:5px;
  margin-bottom:10px;
}
.cur{
  width:100%;
  height:80px;
  padding:20px 0px;
  border:1px solid #155bd4;
  cursor: pointer;
  border-radius:5px;
  margin-bottom:10px;
}

.wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 25px;
  /*no*/

  .wrap-label {
    font-size: 14px;
    /*no*/
    line-height: 32px;
    /*no*/
  }
}

.dContent {
  margin-top: 20px;
  display: flex;
  margin-left: -26%;
  align-items: center;
}

.dLi {
  display: flex;
  align-items: center;
  justify-content: space-between
}

.dCol {
  border: 1px solid #ededed;
  width: 33.33%;
  padding: 15px;
  font-size: 12px;
  text-align: center;
}

/*
.right-aligned-dialog {
  margin-left: auto!important;
  margin-right: 0!important;

 !* ::v-deep .el-dialog {
    margin-left: auto;
    margin-right: 0;
  }*!

}*/

::v-deep .right-aligned-dialog {
  margin-left: auto !important;
  margin-right: 0 !important;
}
.userRole{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top:20px;
}
.setDefaultDec{
  clear: both;display: flex;align-items: center;justify-content: space-between;padding-top:15px;
}

.el-select {
  z-index: 0 !important; /* 根据需要调整 */
}

.el-select-dropdown {
  z-index: 100 !important; /* 根据需要调整 */
}


</style>
